export default "__VITE_ASSET__owJTMCby__"